import { FC } from 'react'
import classNames from 'classnames'
import { Text } from '@/atoms/Text'
import { ReservationVenueSummary, VenueShowtime } from '@/types/codegen-federation'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  theaterName: ReservationVenueSummary['name'] | undefined
  time: VenueShowtime['localStartTimeFriendlyString']
  className?: string
}

export const MovieTicketShowtimeInfo: FC<Props> = ({ theaterName, time, className }) => {
  const { t } = useTranslate('tickets')

  if (!theaterName || !time) return null
  return (
    <div
      className={classNames(
        'flex items-start pt-3 border-t w-full md:px-6 md:py-3 md:rounded-xlmd:bg-black/40 md:backdrop-blur-[72px] md:border-t-0 max-w-[80%] border-t-white/25 justify-center mt-3 gap-3 md:gap-6 md:max-w-[402px] mx-auto',
        className,
      )}
    >
      <div className="flex max-w-[250px] flex-col md:max-w-none">
        <Text className="photon-caption-xs md:photon-caption-sm" color="core-gray-400" weight="medium">
          {t('theater', 'Theater')}
        </Text>
        <Text className="photon-title-xs md:photon-title-md break-words" color="white" weight="medium">
          {theaterName}
        </Text>
      </div>

      <div className="flex shrink-0 flex-col">
        <Text className="photon-caption-xs md:photon-caption-sm" color="core-gray-400" weight="medium">
          {t('time', 'Time')}
        </Text>
        <Text className="photon-title-xs md:photon-title-md" color="white" weight="medium">
          {time}
        </Text>
      </div>
    </div>
  )
}
